<template>
    <div>
        <h1>{{ $t('admin.title') }}</h1>

        <b-modal :title="'Charger'" size="xl" ok-only :id="'load'" static style="">
            <b-form-file
                accept=".json"
                @change="load_from_file"
                placeholder="charger depuis un fichier"></b-form-file> 
        </b-modal>

        <b-container style="margin: 0; padding: 0; max-width: none">
            <b-row ref="div_row">
                <b-col md="auto" ref="div_menu"            >
                    <b-button @click="save" variant="link"><i class="fas fa-save"></i></b-button>
                    <b-button v-b-modal="'load'" variant="link"><i class="fas fa-file-upload"></i></b-button><br />
                    <b-button variant="link" @click="view = 'css'">CSS</b-button><br />
                    <b-button variant="link" @click="view = 'menu'">Menu</b-button><br />
                    <b-button variant="link" @click="view = 'accueil'">Page d'accueil</b-button>
                    <hr />
                    Pages <b-button variant="link" @click="addPage"><i class="fas fa-plus"></i></b-button>
                    <div v-for="(page, idx) in pages" :key="'menu_page-' + idx">
                        <b-button variant="link" @click="view = page.uid">{{page.slug || "Nouvelle page"}}</b-button>
                    </div>
                </b-col>
                <b-col>
                    <div v-show="view == 'css'">
                        CSS, appliqué à tout le site
                        <ace_editor :height="300" mode="html" :code="css" @update="css = $event"></ace_editor>
                        <div v-html="css"></div>
                    </div>
                    <div v-show="view == 'menu'">
                        Menu
                        <draggable :group="'menu'" :list="menu" class="list-group" handle=".handle">
                            <b-card v-for="(item, idx) in menu" :key="'menu-' + idx">
                                Slug de la page
                                <b-input v-model="item.page"></b-input>
                                Nom fr
                                <b-input v-model="item.name_fr"></b-input>
                                Nom en
                                <b-input v-model="item.name_en"></b-input>
                                <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                                <b-button variant="link" @click="removeMenu(idx)"><i class="fas fa-trash"></i></b-button>
                            </b-card>
                        </draggable>
                        <b-button variant="link" @click="addMenu()"><i class="fas fa-plus"></i></b-button>
                    </div>
                    <div v-show="view == 'accueil'">
                        Page d'accueil fr
                        <ace_editor :height="300" mode="html" :code="main_page.fr" @update="main_page.fr = $event"></ace_editor>
                        <page :size="size" lang="fr" :page="main_page.fr" />
                        Page d'accueil en
                        <ace_editor :height="300" mode="html" :code="main_page.en" @update="main_page.en = $event"></ace_editor>
                        <page :size="size" lang="en" :page="main_page.en" />
                    </div>
                    <div v-for="(page, idx) in pages" :key="'page-' + idx">
                        <div v-show="view == page.uid">
                            <b-tabs>
                                <b-tab title="general">
                                    Slug
                                    <b-input v-model="page.slug"></b-input>
                                    Projet
                                    <v-select
                                        v-model="page.project"
                                        :options="projects"
                                        label="name"
                                        :reduce="(option) => option.uid"></v-select>
                                    Colonne de données, pour la saisie manuelle
                                    <b-input v-model="page.column_data"></b-input>
                                    <hr />
                                    <b-button variant="link" @click="removePage(idx)"><i class="fas fa-trash"></i></b-button>
                                </b-tab>
                                <b-tab title="presentation fr">
                                    Présentation française
                                    <ace_editor :height="300" mode="html" :code="page.fr.presentation" @update="page.fr.presentation = $event"></ace_editor>
                                    <page :size="size" lang="fr" :page="page.fr.presentation" />
                                </b-tab>
                                <b-tab title="fr">
                                    Intro fr
                                    <ace_editor :height="300" mode="html" :code="page.fr.intro" @update="page.fr.intro = $event"></ace_editor>
                                    Params fr
                                    <ace_editor :height="300" mode="html" :code="page.fr.text" @update="page.fr.text = $event"></ace_editor>
                                    <product :size="size" :test="true" :test_config="page" lang="fr"/>
                                </b-tab>
                                <b-tab title="presentation en">
                                    Présentation anglaise
                                    <ace_editor :height="300" mode="html" :code="page.en.presentation" @update="page.en.presentation = $event"></ace_editor>
                                    <page :size="size" lang="en" :page="page.en.presentation" />
                                </b-tab>
                                <b-tab title="en">
                                    Intro en
                                    <ace_editor :height="300" mode="html" :code="page.en.intro" @update="page.en.intro = $event"></ace_editor>
                                    Params en
                                    <ace_editor :height="300" mode="html" :code="page.en.text" @update="page.en.text = $event"></ace_editor>
                                    <product :size="size" :test="true" :test_config="page" lang="en"/>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <hr />
        <p>Le saas utilise le système de template <a href="https://handlebarsjs.com/" target="_blank">Handlebars</a> avec le module complémentaire <a href="https://www.npmjs.com/package/just-handlebars-helpers" target="_blank">Just Handlebars Helpers</a>.</p>
        Variables disponible : columns, type_data, identifiant
    </div>
</template>

<script>
    import moment from "moment";
	import { remove } from "lodash";
    import draggable from "vuedraggable";

    import store from "../store";
    import page from "./Page.vue";
    import product from "./Product.vue"
	import utils from "../services/utils.js";
    import shares from "../services/shares.js"
    import products from "../services/products.js";
    import ace_editor from "../components/ace_editor.vue";

    import Handlebars from "handlebars";

	export default {
		name: "admin",
        components:  {
            draggable,
            ace_editor,
            product,
            page
        },
        data: function () {
            return {
                css: "<style></style>",
                menu: [],
                pages: [],
                view: "menu",
                results: {
                    fr: {},
                    en: {}
                },
                projects: [],
                size: 0,
                main_page: {
                    fr: "",
                    en: ""
                }
            }
        },
        methods: {
            async save()
            {
                var data = {
                    css: this.css,
                    menu: this.menu,
                    pages: this.pages,
                    main_page: this.main_page
                }

                utils.saveToFile(
                    JSON.stringify(data),
                    "config-" + moment().format("YYYY-MM-DD HH[h]mm") + ".json"
                );

                try
                {
                    await products.save_admin(data);

                    this.$notify({
                        group: "info",
                        title: "Enrgistrement effectué",
                        type: "success"
                    });
                }
                catch (err)
                {
                    console.log(err);

                    this.$notify({
                        group: "info",
                        title: "Une erreur c'est produite durant l'enregistrement",
                        type: "error",
                    });
                }
            },
            load(data)
            {
                this.css = data.css;
                this.menu = data.menu;
                this.pages = data.pages;
                this.view = data.view;
                if (data.main_page)
                    this.main_page = data.main_page;

				document.body.style.cursor = "default";
            },
			async load_from_file(event) {
				document.body.style.cursor = "wait";
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);

						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
            addPage() 
            {
                this.pages.push({
                    uid: this.$uuid.v4(),
                    slug: "",
                    project: "",
                    column_data: "",
                    fr: {
                        intro: "",
                        text: "",
                        presentation: ""
                    },
                    en: {
                        intro: "",
                        text: "",
                        presentation: ""
                    }
                })
            },
            removePage(idx)
            {
				this.pages.splice(idx, 1);
            },
            addMenu()
            {
                this.menu.push({
                    page: "",
                    name_fr: "",
                    name_en: ""
                })
            },
            removeMenu(idx)
            {
                this.menu.splice(idx, 1);
            },
			onResize() {
				if (this.$refs.div_row)
					this.size =
						this.$refs.div_row.clientWidth -
						this.$refs.div_menu.clientWidth;
			},
        },
		mounted: async function () {
			//console.log(this.$store.state.jwt)

            var self = this;

            if (!store.getters.isUserAdmin) {
				this.$router.push({ name: "profile" });
			}

            var list_get = await shares.list("get", "project");

            for (var i = 0; i < list_get.length; i++)
            {
                this.projects.push({
                    name: list_get[i].details.client_name + " - " + list_get[i].details.name,
                    uid: list_get[i].element_uid
                })
            }

            var data = await products.load_admin();

            this.load(data);


			this.ro = new ResizeObserver(this.onResize).observe(
				this.$refs.div_row
			);

			self.$nextTick(function () {
				self.size =
					self.$refs.div_row.clientWidth -
					self.$refs.div_menu.clientWidth;
			});

		},
	};
</script>

<style></style>
